import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { SearchComponent } from './search/search.component';
import { StatisticComponent } from './statistic/statistic.component';
import { StatPaysComponent } from './stat-pays/stat-pays.component';
import { SearchtermComponent } from './searchterm/searchterm.component';
import { FilterComponent } from './filter/filter.component';
import { AboutComponent } from './about/about.component';


const routes: Routes = [
    { path: "search", component: SearchComponent },
    { path: "advanced", component: AdvancedSearchComponent},
    { path: "statistic", component: StatisticComponent},
    { path: "statpays", component: StatPaysComponent},
    { path: "filter", component: FilterComponent},
    { path: "presentation", component: AboutComponent},
    { path: "", pathMatch: 'prefix', redirectTo: "search" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
